<div
    class="hdmui-p-2 card__content--wrapper"
    [class.low-height]="isLowHeight"
    data-testid="pure-time-mode-page-mat-card-div"
>
    <div class="card__header">
        <h2
            class="hdmui-font-serif hdmui-mx-3"
            [ngClass]="cardHeaderClasses()"
            data-testid="pure-time-mode-page-mat-card-title"
        >
            {{ entry().activity | activityById: activities() | translateActivityName }}
        </h2>
        @if (!isLowHeight && assistants().length > 0) {
            <div
                class="card__assistants"
                [ngClass]="cardHeaderClasses()"
                data-testid="pure-time-mode-page-mat-card-assistants"
            >
                <span class="hdmui-font-bold"> {{ 'DC.JOIN-OR-TAKEOVER.DIALOG.ASSISTANTS' | translate }}: </span>
                @for (assistant of assistants(); track assistant.userId) {
                    <hdmui-avatar
                        [fullName]="assistant.firstName + ' ' + assistant.lastName"
                        [matTooltip]="assistant.firstName + ' ' + assistant.lastName"
                        matTooltipPosition="above"
                        class="hdmui-avatar-small"
                        [attr.data-testid]="'pure-time-mode-page-mat-card-assistant-' + assistant.userId"
                    ></hdmui-avatar>
                }
            </div>
        }
    </div>
    <div class="card__details">
        @if (valuesOnly()) {
            <span class="card__details-values hdmui-mx-3" data-testid="pure-time-mode-page-mat-card-values">
                @if (entry().jobId) {
                    {{ entry().jobId }} | {{ entry().duration | timeFormatter: true : true : true : false }}
                } @else {
                    {{ entry().duration | timeFormatter: true : true : true : false }}
                }
            </span>
        } @else {
            @if (showJobId) {
                <hdmui-key-value
                    [key]="'DC.OPERATIONS.OPERATION_DETAILS.JOB_NUMBER' | translate"
                    data-testid="pure-time-mode-page-mat-card-jobId"
                    >{{ entry().jobId }}
                </hdmui-key-value>
            }
            <hdmui-key-value [key]="'*.duration' | translate" data-testid="pure-time-mode-page-mat-card-duration"
                >{{ entry().duration | timeFormatter: true : true : true : false }}
            </hdmui-key-value>
        }
    </div>
</div>
